<template>
  <div>
    <form v-show="!showVerification" @submit.prevent="getCaptcha" id="homepage-employer-register">
      <section v-if="step == 1">
        <div class="row">
          <div class="col-12 col-lg-6 mt-4 ml-auto mr-auto mb-4">
            <div class="multisteps-form__progress">
              <button
                class="multisteps-form__progress-btn js-active"
                type="button"
                title="User Info"
              >
                Step 1
              </button>
              <button class="multisteps-form__progress-btn" type="button" title="Address">
                Step 2
              </button>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-md-11">
            <div class="row">
              <div class="form-group m-label col-md-12 required">
                <input
                  type="text"
                  id="Company"
                  v-model="postFreeJob.companyName"
                  class="form-control"
                  required
                  @keyup="validate($event)"
                />
                <label for="Company">Company</label>
              </div>
            </div>
            <div class="row">
              <div class="form-group m-label col-md-12 required">
                <input
                  type="text"
                  id="Registration"
                  v-model="postFreeJob.regNumber"
                  class="form-control"
                  required
                  @keyup="validate($event)"
                />
                <label for="Company">Registration number</label>
              </div>
            </div>
            <div class="row">
              <div class="form-group m-label col-md-12 required">
                <input
                  type="text"
                  id="street-address"
                  v-model="postFreeJob.address"
                  class="form-control"
                  @keyup="validate($event)"
                  required
                  autocomplete
                />
                <label for="street-address">Street address</label>
              </div>
            </div>
            <div class="row">
              <div class="form-group m-label col-md-4 required">
                <input
                  type="text"
                  v-model="postFreeJob.postal"
                  class="form-control"
                  id="postal"
                  @keyup="validate($event)"
                />
                <label for="postal">Postal code</label>
              </div>

              <div class="form-group m-label filter-item col-md-8 required">
                <v-select
                  v-model="postFreeJob.cityId"
                  label="name"
                  :options="[...getCitiesListByCountry]"
                  :reduce="res => res.id"
                  :clearable="false"
                  @change="validate($event)"
                  placeholder="City"
                  id="city"
                >
                  <template v-slot:no-options>
                    <div style="opacity: 0.5">You must choose country first</div>
                  </template>
                </v-select>
                <label for="city">City</label>
              </div>
            </div>
            <div class="form-group m-label-left filter-item required-right">
              <!-- <FloatLabel label="City"> -->
              <!--  @search="fetchOptionsForCountries" -->
              <v-select
                v-model="postFreeJob.countryName"
                @input="fetchCitisByCountryId($event)"
                :options="[...getAllCountries]"
                label="name"
                placeholder="Country"
                :reduce="res => res"
                :clearable="false"
                required
              ></v-select>
              <!-- </FloatLabel> -->
              <label for="country">Country</label>
            </div>
          </div>
        </div>
      </section>

      <section v-if="step == 2">
        <div class="row">
          <div class="col-12 col-lg-6 mt-4 ml-auto mr-auto mb-5">
            <div class="multisteps-form__progress">
              <button class="multisteps-form__progress-btn" type="button" title="User Info">
                Step 1
              </button>
              <button class="multisteps-form__progress-btn js-active" type="button" title="Address">
                Step 2
              </button>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-md-11">
            <div class="row">
              <div class="form-group m-label col-md-6 required">
                <input
                  @keyup="validate($event)"
                  type="text"
                  id="first-name"
                  v-model="postFreeJob.firstName"
                  class="form-control"
                  required
                />
                <label for="first-name">First name</label>
              </div>
              <div class="form-group m-label col-md-6 required">
                <input
                  type="text"
                  id="last-name"
                  v-model="postFreeJob.lastName"
                  class="form-control"
                  @keyup="validate($event)"
                  required
                />
                <label for="last-name">Last name</label>
              </div>
            </div>
            <div class="row">
              <div class="form-group m-label col-md-12 required">
                <div>
                  <input
                    type="email"
                    id="email"
                    v-model="postFreeJob.email"
                    class="form-control"
                    @keyup="validate($event)"
                    :class="emailNotFalid ? 'is-invalid' : ''"
                    required
                  />
                  <label for="email">Corporate email</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group m-label col-md-4">
                <div
                  class="form-control customform no-hor"
                  style="height: 48px; position: relative"
                >
                  <v-select
                    @input="addCountryCode(postFreeJob.phone_code)"
                    style="position: absolute; left: 0; top: 6px; width: 100%"
                    v-model="postFreeJob.phone_code"
                    :options="[...getAllCountries].map(item => `${item.phone_code} ${item.name}`)"
                    :clearable="false"
                  >
                    <template v-slot:option="option">
                      {{ option.label }}
                    </template>
                  </v-select>
                </div>
                <label for="country-code">Country code</label>
              </div>
              <div class="form-group m-label col-md-8 required">
                <input
                  type="tel"
                  id="phone"
                  v-model="postFreeJob.phone"
                  class="form-control"
                  @keyup="validate($event)"
                  required
                />
                <label for="phone">Phone number</label>
              </div>
              <div class="form-group m-label col-md-12">
                <input
                  type="text"
                  id="Corporate-website"
                  v-model="postFreeJob.corporateWebsite"
                  class="form-control"
                />
                <label for="Corporate-website">Corporate website</label>
              </div>
              <div class="form-group m-label col-md-12 required">
                <div>
                  <input
                    type="password"
                    id="post-free-job-password"
                    class="form-control"
                    v-model="postFreeJob.password"
                    @keyup="validate($event)"
                    required
                    placeholder="Minimum 8 characters"
                  />
                  <label for="post-free-job-password">Password</label>
                </div>
              </div>
              <div class="form-group col-md-12 mb-0">
                <div class="agreement">
                  <div class="custom-control custom-checkbox">
                    <input
                      v-model="postFreeJob.isAgree"
                      type="checkbox"
                      class="custom-control-input"
                      id="customCheck122"
                    />
                    <label class="custom-control-label" for="customCheck122"
                      >I agree to
                      <router-link
                        target="_blank"
                        style="text-decoration: none"
                        :to="{ name: 'employers' }"
                        >Jobshark's General Conditions for Employers</router-link
                      ></label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Nav btn's -->
      <div class="row mb-2 mt-4">
        <div class="col-md-11 mx-auto">
          <div class="row justify-content-around">
            <div class="col-4 text-center">
              <!-- <div class="text-center mt-3 d-flex"> -->

              <button
                class="btn btn-primary btn-custom prev w-100"
                @click="prev"
                :disabled="step == 1 || step < 0"
              >
                <i class="fa fa-chevron-left mr-3"></i>Back
              </button>
            </div>

            <div class="col-4 text-center">
              <button
                v-if="step == 2"
                type="submit"
                class="btn btn-success btn-custom mr-2 w-100"
                :disabled="!canPost"
              >
                Sign Up
              </button>

              <button
                v-else
                type="button"
                form="add-for-job"
                class="btn btn-secondary btn-custom w-100"
                :disabled="!nextStep"
                @click="next"
              >
                Next
                <i class="fa fa-chevron-right ml-3"></i>
              </button>
            </div>
          </div>

          <div class="footer-small-link mt-3">
            <p class="text-center">
              <button
                style="background: none; border: none; color: #0088cc"
                id="already-have-account"
                @click="$emit('open-candidate-register', $event)"
              >
                I'm a candidate and want to sign up
              </button>
            </p>
          </div>
        </div>
      </div>
      <Spinner :isLoading="isLoading" />
    </form>
    <VerificationCodeEmployer v-show="showVerification" />
  </div>
</template>

<script>
import axios from 'axios';
import VerificationCodeEmployer from '../../views/PublicPagesBase/VerificationCodeEmployer';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    VerificationCodeEmployer,
  },
  data: () => ({
    retoken: '',
    isLoading: false,
    showResetPassword: false,
    showLogin: false,
    showRegister: false,
    openEmailVerification: false,
    showModal: false,
    showModalJob: false,
    step: 1,
    showVerification: false,
    nextStep: false,
    validCity: false,
    validCountry: false,
    canPost: false,
    emailNotFalid: false,
    emailValidated: false,
    phoneValidated: false,
    postFreeJob: {
      phone: '',
      email: '',
      companyName: '',
      countryId: '',
      address: '',
      postal: '',
      city: '',
      cityId: '',
      countryName: '',
      corporateWebsite: '',
      firstName: '',
      lastName: '',
      password: '',
      phone_code: '',
      regNumber: '',
      isAgree: false,
      campaign_id: null,
      campaign_medium: null,
      campaign_name: null,
      campaign_source: null,
    },
  }),

  methods: {
    ...mapActions([
      'retrieveEmployersDropdownCandidate',
      'searchLocationByName',
      'retrieveCitiesListByCountryId',
      'retrieveAllCountries',
    ]),
    getCaptcha() {
      let vm = this;
      const REG = () => this.registerEmployer();
      grecaptcha
        .execute('6LdyDhspAAAAAJWVsgRkufJ8fAJBeSDpWDPUsvAn', { action: 'submit' })
        .then(function(token) {
          vm.reToken = token;
          REG();
        });
    },

    registerEmployer() {
      if (!this.postFreeJob.isAgree) {
        this.$toasted.error(
          `Please agree to Jobshark's General Conditions for Employers to register`,
          {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          },
        );
        return false;
      }

      this.isLoading = true;

      axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/manager/auth/register`,
        data: {
          email: this.postFreeJob.email,
          password: this.postFreeJob.password,
          company_name: this.postFreeJob.companyName,
          first_name: this.postFreeJob.firstName,
          last_name: this.postFreeJob.lastName,
          city_id: this.postFreeJob.cityId,
          country_id: this.postFreeJob.countryId,
          street_address: this.postFreeJob.address,
          website: this.postFreeJob.corporateWebsite,
          phone_number: this.postFreeJob.phone,
          country_code: this.postFreeJob.phone_code,
          postal_code: this.postFreeJob.postal,
          privacy: this.postFreeJob.isAgree,
          registration_number: this.postFreeJob.regNumber,
          'g-recaptcha-response': this.reToken,
          campaign_id: this.postFreeJob.campaign_id,
          campaign_medium: this.postFreeJob.campaign_medium,
          campaign_name: this.postFreeJob.campaign_name,
          campaign_source: this.postFreeJob.campaign_source,
        },
      })
        .then(response => {
          localStorage.setItem('uuid', response.data.id);

          this.showVerification = true;
          this.isLoading = false;
        })

        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(`${err.response.data.message}`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    getDefaultCountry() {
      const sweden = this.getAllCountries.find(country => country.name === 'Sweden');
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/address/getaddressbyip`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          this.isLoading = false;
          if (!data.country_name) {
            this.postFreeJob.countryName = sweden.name;
            this.postFreeJob.countryId = sweden.id;
            this.postFreeJob.phone_code = sweden.name;
            this.retrieveCitiesListByCountryId({ id: sweden.id });
          } else {
            this.postFreeJob.countryName = data.country_name;
            this.postFreeJob.countryId = data.country_id;
            this.postFreeJob.phone_code = data.country_name;
            this.postFreeJob.city = data.city_name;
            this.postFreeJob.cityId = data.city_id;
            this.retrieveCitiesListByCountryId({ id: data.country_id });
          }
          if (data.phone_code !== null) {
            this.postFreeJob.phone = `${data.phone_code} `;
          } else {
            this.postFreeJob.phone = `${sweden.phone_code} `;
          }
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    next() {
      if (this.step < 2) {
        this.step++;
      }
    },
    prev() {
      this.step--;
    },
    validate(el) {
      if (el.target.required === true && el.target.value === '') {
        el.target.classList.add('is-invalid');
      } else {
        el.target.classList.remove('is-invalid');
      }

      if (el.target.type === 'email') {
        this.validateEmail(this.postFreeJob.email);
      }

      if (el.target.type === 'password' && el.target.value.length < 8) {
        el.target.classList.add('is-invalid');
      } else {
        el.target.classList.remove('is-invalid');
      }
    },
    validateEmail(email) {
      const emailRe = /^(([^<>()[\]\\.,;:#/\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // const emailRe = /^(([^<>()\[\]\\.,;:#/\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (email.length > 0) {
        if (emailRe.test(email)) {
          this.postFreeJob.emailNotFalid = false;
          this.postFreeJob.emailValidated = true;
        } else {
          this.postFreeJob.emailNotFalid = true;
          this.postFreeJob.emailValidated = false;
        }
      }
    },
    fetchCitisByCountryId(e) {
      this.postFreeJob.city = '';
      this.postFreeJob.cityId = '';
      this.postFreeJob.countryName = e.name;
      this.postFreeJob.countryId = e.id;
      this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
    },
    addCountryCode(code) {
      this.postFreeJob.phone_code = code.replace(/[0-9+]/g, '');
      this.postFreeJob.phone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    getCampainParams() {
      if (this.$route.query.utm_id) {
        this.postFreeJob.campaign_id = this.$route.query.utm_id;
      }
      if (this.$route.query.utm_medium) {
        this.postFreeJob.campaign_medium = this.$route.query.utm_medium;
      }
      if (this.$route.query.utm_campaign) {
        this.postFreeJob.campaign_name = this.$route.query.utm_campaign;
      }
      if (this.$route.query.utm_source) {
        this.postFreeJob.campaign_source = this.$route.query.utm_source;
      }
    },
  },
  watch: {
    postFreeJob: {
      handler(val) {
        if (
          val.companyName &&
          val.countryId &&
          val.address &&
          val.postal &&
          val.cityId &&
          val.regNumber
        ) {
          this.nextStep = true;
        } else {
          this.nextStep = false;
        }
        if (
          this.nextStep &&
          val.firstName &&
          val.lastName &&
          val.password.length >= 8 &&
          val.phone &&
          val.email.length > 0
        ) {
          this.canPost = true;
        } else {
          this.canPost = false;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      'getNextPage',
      'getTotalPages',
      'getCurrentPage',
      'getAllCountries',
      'allSearchJobResults',
      'getCompetencesFilterList',
      'getCitiesListByCountry',
      'getEmployersDropdownCandidate',
    ]),
  },
  mounted() {
    this.getDefaultCountry();
    this.getCampainParams();
  },
};
</script>
<style lang="scss" scoped>
.form-group.required {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 26px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 10px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 6px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-drop {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 25px;
    color: red;
    opacity: 0.6;
  }
}
.multisteps-form__progress {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}

.multisteps-form__progress-btn {
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  position: relative;
  padding-top: 20px;
  color: rgba(108, 117, 125, 0.7);
  text-indent: -9999px;
  border: none;
  background-color: transparent;
  outline: none !important;
  cursor: pointer;
}

.no-padding {
  padding-left: 8px;
  padding-top: 15px;
}

@media (min-width: 500px) {
  .multisteps-form__progress-btn {
    text-indent: 0;
  }
}

.multisteps-form__progress-btn:before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 13px;
  height: 13px;
  content: '';
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  transition: all 0.15s linear 0s, -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s,
    -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  border: 2px solid currentColor;
  border-radius: 50%;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 3;
}

.multisteps-form__progress-btn:after {
  position: absolute;
  top: 5px;
  left: calc(-50% - 13px / 2);
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  display: block;
  width: 100%;
  height: 2px;
  content: '';
  background-color: currentColor;
  z-index: 1;
}

.multisteps-form__progress-btn:first-child:after {
  display: none;
}

.multisteps-form__progress-btn.js-active {
  color: #0088cc;
}

.multisteps-form__progress-btn.js-active:before {
  -webkit-transform: translateX(-50%) scale(1.2);
  transform: translateX(-50%) scale(1.2);
  background-color: currentColor;
}
</style>
